import React from 'react';

// Pills. `default` is the one filled CTA (off-white on dark, near-black on
// light); everything else is hairline or text. Gold is never a button colour.
const Button = React.forwardRef(({
  className = '',
  variant = 'default',
  size = 'default',
  children,
  ...props
}, ref) => {
  const baseClasses = "inline-flex items-center justify-center gap-1.5 rounded-full text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-fg-3 focus-visible:ring-offset-2 focus-visible:ring-offset-canvas disabled:opacity-50 disabled:pointer-events-none";

  const variantClasses = {
    default: "bg-cta text-cta-fg hover:bg-cta-hover",
    destructive: "bg-off-strong dark:bg-off text-white hover:opacity-90",
    outline: "border border-line-strong bg-transparent text-fg-2 hover:text-fg hover:border-fg-3",
    secondary: "bg-elev border border-line text-fg hover:border-line-strong",
    ghost: "bg-transparent text-fg-2 hover:text-fg hover:bg-raised",
    link: "underline-offset-4 hover:underline text-fg-2 hover:text-fg",
  };

  const sizeClasses = {
    default: "h-10 px-4",
    sm: "h-9 px-3.5",
    lg: "h-12 px-7 text-base",
    icon: "h-10 w-10",
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <button className={classes} ref={ref} {...props}>
      {children}
    </button>
  );
});

Button.displayName = "Button";

export { Button };
